/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import providerApi from "../../modules/tp/providers/_requests";
import { Column } from "app/partials/entity/Table";
import PageWrapper from "app/partials/entity/PageWrapper";
import { emptyProvider, Provider } from "app/modules/tp/providers/_models";
import ProviderFormBuilder from 'app/modules/tp/providers/builders/ProviderFormBuilder';
import { Referent } from 'app/modules/tp/referents/_models';

const columns: Array<Column<Provider>> = [
    {
        key: "name",
        label: "Nome",
        filterable: true,
        sortable: true,
    },
    {
        key: "referents",
        label: "Referente",
        render: (provider: Provider) => (<>{provider.referents?.map((referent: Referent )=> `${referent.name ?? ""} ${referent.surname ?? ""}`).join(", ")}</>)
    },
    {
        key: "nVeichles",
        label: "Mezzi",
    },
    {
        key: "nDrivers",
        label: "Autisti",
    },
]

const entityIcon = "fa-solid fa-handshake-simple";

const ProvidersPage: FC = () => {
    return (
                <PageWrapper
                    columns={columns}
                    emptyEntity={emptyProvider}
                    entityIcon={entityIcon}
                    entityApi={providerApi}
                    labels={{
                        icon: entityIcon,
                        singleEntityName: "Fornitore",
                        pluralEntityName: "Fornitori",
                    }}
                    form={ProviderFormBuilder()}
                />
    );
}


export { ProvidersPage }
